var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNoImageInRow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 75,
    viewBox: "0 0 56 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 74,
    x: 0.5,
    y: 0.5,
    fill: "#FFF",
    stroke: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M31.576243,36.090629 C32.6906453,36.090629 33.5970984,35.1767903 33.5970984,34.0536452 C33.5970984,32.9301935 32.6906453,32.0166613 31.576243,32.0166613 C30.4615385,32.0166613 29.5547831,32.9301935 29.5547831,34.0536452 C29.5547831,35.1767903 30.4615385,36.090629 31.576243,36.090629 Z M37.0412574,44.3332581 L37.0412574,41.9052419 L35.2029621,40.1318065 L32.7160345,42.3995484 C32.2789784,42.7761774 31.6666163,42.7688226 31.2374188,42.3833065 L24.8843887,36.762371 L18.630195,41.9214839 L18.630195,44.3332581 L37.0412574,44.3332581 Z M18.630195,30.6664355 L18.630195,38.8925161 L24.1870938,34.3276129 C24.6244522,33.959871 25.3166087,33.9715161 25.7412725,34.3536613 L31.9972797,39.9654032 L34.6090373,37.7093065 C35.0394439,37.3381935 35.5157927,37.3388065 35.9458969,37.7117581 L37.0412574,38.8339839 L37.0412574,30.6664355 L18.630195,30.6664355 Z M40,45.666629 C40,46.4030323 39.4112135,47 38.6849025,47 L17.3150975,47 C16.5887865,47 16,46.4030323 16,45.666629 L16,29.333371 C16,28.5966613 16.5887865,28 17.3150975,28 L38.6849025,28 C39.4112135,28 40,28.5966613 40,29.333371 L40,45.666629 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoImageInRow);
export default __webpack_public_path__ + "static/media/icon_no_image_in_row.c74200aa.svg";
export { ForwardRef as ReactComponent };